import React, { Component } from 'react';

import CompanyInfo from '../CompanyInfo';

import styles from './styles.module.css';

import AnnaLogo from './images/AnnaLogo.svg';

class Header extends Component {
  render() {
    return (
      <div className={styles.Header}>
        <div className={styles.Title}>
          <img
            src={AnnaLogo}
            alt="Anna"
          />
        </div>
        <CompanyInfo />
      </div>
    );
  }
}

export default Header;
